






































































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';

@Component({
    components: {
        Button
    }
})
export default class ModalSmartRoute extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: false}) savingSmartRoute: boolean;
    @Prop({default: null}) smartRouteStartPoint: google.maps.LatLng | null;

   
    @Emit()
    closeModal() {}

    @Emit()
    cancelSmartRoute() {}

    @Emit()
    saveSmartRoute() {}

    mounted() {}
}
